import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd, IoIosClose } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal/Modal'
import { deleteSchoolWeek, setPage } from '../../actions/schoolWeeks'
import Table from '../../components/Table'
import Select from '../../components/Select'
import { getSchoolYears, getSchoolClassByYear } from '../../actions/common'
import Confirmation from '../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import { deleteParentMeeting, getParentMeetingsList } from '../../actions/parent_meetings'
import moment from 'moment'
import { getStudyPeriod } from '../../actions/classbook'
import { getCurrentYearUtils } from '../../utils/classBook'



export default function ParentMeetings() {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { schoolYears, classesByYear } = useSelector(state => state.common)
  const { parentMeetings, } = useSelector(state => state.parent_meetings)

  const [selectedItem, setSelectedItem] = useState(null)
  const { studyPeriod } = useSelector(state => state.classbook)
  const [parentMeetingForDelete, setParentMeetingForDelete] = useState(null)
  const [formData, setFormData] = useState({})


  useEffect(() => {
    dispatch(getSchoolYears())
  }, [])

  useEffect(() => {
    const currYear = getCurrentYearUtils(schoolYears, new Date())
    !!schoolYears.length && setFormData({ scYear: currYear })
  }, [schoolYears])

  useEffect(() => {
    formData.scYear &&
      dispatch(getStudyPeriod(formData))
  }, [formData.scYear])

  useEffect(() => {
    if (formData.studyPeriod || formData.scYear) {
      dispatch(getParentMeetingsList(formData))
      dispatch(getSchoolClassByYear(formData))

    }
    if (formData.studyPeriod) {
      dispatch(getParentMeetingsList(formData))
      dispatch(getSchoolClassByYear(formData))
    }
  }, [formData.scYear, formData.studyPeriod])

  useEffect(() => () => dispatch(setPage(0)), [])


  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const renderOptions = ({ name, title, xp_key, trmid }) => <option key={trmid || xp_key} value={trmid || xp_key}>{name || title}</option>

  const deleteClickHandler = (wid) => (e) => {
    e.stopPropagation()
    setParentMeetingForDelete(wid)
  }

  const acceptConfirm = () => {
    dispatch(deleteParentMeeting(parentMeetingForDelete.id, formData))
    setParentMeetingForDelete(null)
  }

  const rejectConfirm = () => {
    setParentMeetingForDelete(null)
  }

  const renderLi = (data) => {
    const { begintime, endtime, room, classes, date, pmid } = data
    return (
      <tr onClick={openModal(data)} style={{ cursor: 'pointer', background: 'white' }}>
        <td>{moment(date).format('DD.MM.YYYY')}</td>
        <td>{begintime}</td>
        <td>{endtime}</td>
        <td>{room}</td>
        <td>{classes}</td>
        <td><i className={styles.trash} onClick={deleteClickHandler({ id: pmid, name: room })}><BiTrash /></i></td>
      </tr >
    )
  }

  return (
    <div className={styles.wrapper}>
      {parentMeetingForDelete &&
        <Confirmation
          title={`Вы уверены что хотите удалить ${parentMeetingForDelete.name}?`}
          acceptConfirmation={acceptConfirm}
          rejectConfirmation={rejectConfirm}
        />
      }
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          handleInputChange={handleInputChange}
          params={formData}
          addMode={!selectedItem?.pmid}
        />
      }
      <h1>Родительские собрания</h1>

      <div className={styles.selects}>
        <Select
          title="Год"
          name={"scYear"}
          options={[{ name: "Выбрать" }, ...schoolYears]}
          value={formData?.scYear}
          withoutArrowMode
          onChange={handleInputChange}
        />
        <Select
          title="Учебный период"
          name={"studyPeriod"}
          options={[{ name: "Выбрать" }, ...studyPeriod]}
          value={formData?.studyPeriod}
          withoutArrowMode
          onChange={handleInputChange}

        />
      </div>
      <Table style={{ marginTop: '2rem', backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th>Дата</th>
            <th>Начало</th>
            <th>Окончание</th>
            <th>Кабинет</th>
            <th>Классы</th>
          </tr>
        </thead>
        <tbody>
          {parentMeetings?.map(renderLi)}
        </tbody>
      </Table>

      <Button
        style={{ padding: '.5rem 1.5rem' }}
        onClick={openModal()}
      >
        <IoIosAdd size={30} />
        Добавить
      </Button>
    </div>
  )
}